/** Public path for the default Open Graph / Twitter share image (in `public/`). */
export const DEFAULT_OG_IMAGE_PATH = '/og-default.png';

export function getPublicSiteUrl() {
  const env = process.env.REACT_APP_PUBLIC_SITE_URL;
  if (env && typeof env === 'string') {
    return env.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/** Absolute URL for the site-wide default social preview image. */
export function getDefaultOgImageUrl() {
  const siteUrl = getPublicSiteUrl();
  if (!siteUrl) return '';
  return `${siteUrl}${DEFAULT_OG_IMAGE_PATH}`;
}
